import { Link } from "react-router-dom";
import { Apple, Smartphone } from "lucide-react";
import { LOGO_ICON } from "@/lib/brand";

export default function Footer() {
  return (
    <footer className="bg-primary text-background py-16 sm:py-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={LOGO_ICON} alt="My Clean Connect" className="h-10 w-auto object-contain brightness-0 invert" />
              <span className="font-display text-lg font-bold text-white">My Clean Connect<sup className="text-[0.5em]">™</sup></span>
            </div>
            <p className="text-background/60 text-sm leading-relaxed max-w-xs">
              Connecting you with trusted, insured and DBS-checked local cleaners across the UK.
            </p>
          </div>
          <div>
            <h4 className="font-display font-medium mb-4">Company</h4>
            <ul className="space-y-3 text-sm text-background/60">
              <li><a href="/#how" className="hover:text-accent transition-colors">How it works</a></li>
              <li><Link to="/register?role=cleaner" className="hover:text-accent transition-colors">Become a Cleaner</Link></li>
              <li><a href="/#faq" className="hover:text-accent transition-colors">FAQ</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-medium mb-4">Services</h4>
            <ul className="space-y-3 text-sm text-background/60">
              <li><Link to="/search?service=domestic-cleaning" className="hover:text-accent transition-colors">Domestic Cleaning</Link></li>
              <li><Link to="/search?service=deep-cleaning" className="hover:text-accent transition-colors">Deep Cleaning</Link></li>
              <li><Link to="/search?service=end-of-tenancy" className="hover:text-accent transition-colors">End of Tenancy</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-medium mb-4">Get the app</h4>
            <div className="space-y-3">
              <button className="w-full inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background/20 text-sm hover:bg-background/10 transition-colors" data-testid="app-store-btn">
                <Apple className="h-4 w-4" /> App Store
              </button>
              <button className="w-full inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background/20 text-sm hover:bg-background/10 transition-colors" data-testid="play-store-btn">
                <Smartphone className="h-4 w-4" /> Google Play
              </button>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-background/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-background/50">
          <p>© {new Date().getFullYear()} My Clean Connect™ Ltd. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="/#" className="hover:text-accent transition-colors">Privacy</a>
            <a href="/#" className="hover:text-accent transition-colors">Terms</a>
            <a href="/#" className="hover:text-accent transition-colors">GDPR</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
